import { render, staticRenderFns } from "./DefaultModal.vue?vue&type=template&id=bf5b0406&scoped=true"
import script from "./DefaultModal.vue?vue&type=script&lang=ts"
export * from "./DefaultModal.vue?vue&type=script&lang=ts"
import style0 from "./DefaultModal.scss?vue&type=style&index=0&id=bf5b0406&prod&scoped=true&lang=scss&external"
import style1 from "./DefaultModal.vue?vue&type=style&index=1&id=bf5b0406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5b0406",
  null
  
)

export default component.exports